import {CollectionItem} from 'data/records'
import {resource, collection as c, findSelector} from 'data/helpers/apiv3'

const [api, actions] = resource(CollectionItem, [
  ['create', c.post('', ['collectionItem'])],
  ['list', c.get('', ['collectionId'])],
  ['reorder', c.post('reorder', ['collectionId', 'order'])]
])

const selectors = {
  ...findSelector(CollectionItem),
  byCollectionId: (state, collectionId) => {
    return state.apiv3.collectionItem.id.filter(ci => ci.collectionId === collectionId).sortBy(i => i.position)
  },
  byItem: (state, id, type) => state.apiv3.collectionItem.id.find(
    ci => ci.itemType === type && ci.itemId === id
  )
}

const reducers = {}

const initialState = {}

export {
  api as collectionItemApi,
  actions as collectionItemActions,
  selectors as collectionItemSelectors,
  reducers as collectionItemReducers,
  initialState as collectionItemInitialState
}
